import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatPaginator, MatDialog, MatSort } from '@angular/material';
import { ItemGrid } from '../../models/item';
import { modalComponent } from '../../utils/modal/modal.component';
import { PersonalPDF, Personal } from '../../models/personal';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import { generalService } from '../../services/general.service';
import { DataService } from '../../utils/data.service';
import { ItemSat } from '../../models/item-sat';
import { DataSourceGrid } from '../../utils/data-source-grid.component';
import { ActivatedRoute } from '@angular/router';
import { ItemSatAddEditComponent } from '../agregar-editar/itemSat-agregar-editar'


@Component({
    selector: 'itemSat-consultar',
    styleUrls: [], 
    templateUrl: 'itemSat-consultar.component.html',
    providers: [generalService]
})
export class ItemSatConsultarComponent implements OnInit{

    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    dataSource: DataSourceGrid | null;
    displayedColumns = ['acciones', 'NAME_SAT','DESCRIPTION',
    //'TYPE'
    ];
    public list_ItemSat: any[] = [];
    public menuItemsPerfil: Array<any> = [];
    public iconoMostar = true;
    constructor(private _generalService: generalService, 
        public dataService: DataService, 
        public dialog: MatDialog,
        public _activated : ActivatedRoute) {
    }

    ngOnInit() {
        this.consultarItemSat();
    }

    consultarItemSat(){
        let metodo = 'Item/consultItemSat';
       
        const params = { 
          loacs: sessionStorage.getItem('acslo')  
        };

        this._generalService.metodoCallParams(params, metodo,true).subscribe(
          result => {
            this.list_ItemSat = JSON.parse(result);
        
            this.dataSource = new DataSourceGrid(this.list_ItemSat, this.paginator, this.sort);
        
            
            if(this.list_ItemSat.length <= 0)
              { $(".mat-row").remove(".mat-row"); }
            
            },
          error => {  console.log(<any>error);  }
        );
    }
    searchFilter(searchTerm: string) {
        if(this.list_ItemSat.length <= 0) {
          this.dataSource = undefined;
        } else {
          let filtroVehiculos = this.list_ItemSat;
          if(searchTerm != "") {
            filtroVehiculos = this.list_ItemSat.filter((obj: any) => {            
              if (obj.NAME_SAT.toLowerCase().indexOf(searchTerm.toLowerCase()) != -1 
              || obj.DESCRIPTION && obj.DESCRIPTION.toLowerCase().indexOf(searchTerm.toLowerCase()) != -1 
              )
                  return true;
              else
                  return false;
            });
          }
          this.dataSource = new DataSourceGrid(filtroVehiculos, this.paginator, this.sort);
        }
    }
    addEditItemSat(id: number) {
      const dialogRef = this.dialog.open(ItemSatAddEditComponent, {
       disableClose: true, 
       width:'50%', 
       maxWidth:'70%', 
       panelClass: 'full-width-dialog',
       data: {ITEM_SAT_ID:id}
      });
      this.dataService.dialogRef = dialogRef; 
    
      this.dataService.dialogRef = dialogRef;
      dialogRef.afterClosed().subscribe((result) => {
          this.consultarItemSat();
      });
    }

    validarVistaBtn(){
      let personal = new Personal();
      const permisoIcono = 'MENU0024'
      personal.loacs = sessionStorage.getItem("acslo");
      this._generalService.metodoCallParams(personal, "usuario/consultarMenu").subscribe(
        result => {
          this.menuItemsPerfil = JSON.parse(result);
          for(let menu of this.menuItemsPerfil) {
            if(permisoIcono == menu.codigo) {
              this.iconoMostar = false;
            }else{
              this.iconoMostar = true;
            }
          }
        }, 
        error => {
          console.log(error);
        }
      )
    }

}


// WEBPACK FOOTER //
// ./src/app/itemSat/consultar/itemSat-consultar.component.ts